<template>
	<div class="deviceNew">
		<div class="deviceBuyout__title">
			<span class="step">3/{{ totalSteps }}</span>
			<slot name="bonusPhoneTitle">
				{{ $t('buyout.bonus.select_your_new_device', [campaign.new_devices]) }}
			</slot>
		</div>
		<v-autocomplete
			v-model="selectedBonus"
			:items="usableBuyoutBonuses"
			:disabled="!isRegistration || !isBuyoutEditable"
			item-text="label"
			item-value="id"
			:placeholder="
				$t('buyout.bonus.select_your_new_device', [campaign.new_devices])
			"
			autocomplete="off"
			return-object
			required
		/>
		<v-autocomplete
			v-model="selectedPartner"
			:items="partners"
			:disabled="!isRegistration || !isBuyoutEditable"
			item-text="label"
			item-value="id"
			:placeholder="
				$t('buyout.bonus.select_seller_of_your_new_device', [
					campaign.new_devices
				])
			"
			autocomplete="off"
			return-object
			required
		/>
	</div>
</template>

<script>
import { getters, mutations } from '../../../store/buyout';

export default {
	name: 'BuyoutBonus',
	computed: {
		...getters,
		selectedBonus: {
			get: () => getters.selectedBonus(),
			set: v => mutations.setSelectedBonus(v)
		},
		selectedPartner: {
			get: () => getters.selectedPartner(),
			set: v => mutations.setSelectedPartner(v)
		}
	}
}
</script>
